import React, { useState, useMemo, useCallback } from "react";
import { useAuth } from "../../Context/store/context";
import { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import config from "../../../config";
import { _get, _post, _delete, _put } from "../../../apiClient";
import { IconTrash } from '@tabler/icons-react';

const loadRazorpayScript = (src) => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};

export default function PackagesCart() {
  const { user, setpackagescartitems, PackagesCartItems, logoutuser, showLoader, hideLoader, getToken } = useAuth();
  const min = 1;
  const adminreduxinfo = useSelector((state) => state.admininfo.admininfo);
  const [aggregatedItems, setAggregatedItems] = useState([]);

  const [subtotal, setSubtotal] = useState(0);
  const [gst, setGst] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const Navigate = useNavigate()

  useEffect(() => {
    if (adminreduxinfo && PackagesCartItems) {
      getCartItems();
    }
  }, [adminreduxinfo]);

  useEffect(() => {
    if (PackagesCartItems && PackagesCartItems.length > 0) {
      setAggregatedItems(PackagesCartItems);
    }
  }, [PackagesCartItems]);

  const getCartItems = async () => {
    showLoader();
    await _get(`/app-user-cart-items`,
    ).then(response => {
      setAggregatedItems(response);
      hideLoader();
    }).catch(error => {
      if (error)
      hideLoader();
    });
  }

  const handleQtyChange = useCallback(
    (index, newQty) => {
      if (newQty >= min) {
        setAggregatedItems((prevItems) => {
          const updatedItems = [...prevItems];
          updatedItems[index] = { ...updatedItems[index], quantity: newQty };
          return updatedItems;
        });
      }
    }
  );

  const handleClick = useCallback(
    (index, action) => {
      setAggregatedItems((prevItems) => {
        const updatedItems = [...prevItems];
        let value = updatedItems[index].quantity;
        if (action === "add") {
          value = value + 1;
        } else {
          value = value <= min ? min : value - 1;
        }
        updatedItems[index] = { ...updatedItems[index], quantity: value };
        return updatedItems;
      });
    }
  );

  function getBasePrice(cartItem) {
    if (cartItem.isInclusiveOfTax) {
      let amount = cartItem.price * cartItem.quantity;
      return amount * (100 / (100 + cartItem.taxPercentage))

    } else {
      return cartItem.price * cartItem.quantity;
    }
  }

  function getTax(cartItem) {
    if (cartItem.isInclusiveOfTax) {
      let amount = cartItem.price * cartItem.quantity;
      return (amount - amount * (100 / (100 + cartItem.taxPercentage)))

    } else {
      let amount = cartItem.price * cartItem.quantity;
      return amount * (cartItem.taxPercentage / 100);
    }
  }

  useEffect(() => {
    let totalBaseAmount = 0;
    let taxAmount = 0;
    let grandTotal = 0;

    for (const item of aggregatedItems) {
      totalBaseAmount = totalBaseAmount + getBasePrice(item);
      taxAmount = taxAmount + getTax(item);
      grandTotal = (item.quantity * item.finalPrice);
    }
    setSubtotal(totalBaseAmount);
    setGrandTotal(grandTotal);
    setGst(taxAmount);
  }, [aggregatedItems]);

  const renderedAggregatedItems = useMemo(() => {
    return aggregatedItems.map((item, index) => (
      <tr key={item.id}>
        <td>{index + 1}</td>

        <td>{item.name} <br /><small style={{ fontSize: "10px" }}> {item.isInclusiveOfTax ? "(Inclusive of all taxes)" : "(Exclusive of all taxes)"}</small></td>
        <td>{item.finalPrice.toLocaleString("en-US", { style: "currency", currency: "INR" })}</td>
        <td>
          {!item.isForTrail &&
            <div className="qty-input" style={{ width: "fit-content" }}>
              <button
                className="qty-count qty-count--minus"
                onClick={() => handleClick(index, "subtract")}
                disabled={item.quantity <= min}
              >
                -
              </button>
              <input
                type="number"
                className="product-qty"
                value={item.quantity}
                onChange={(e) => handleQtyChange(index, parseInt(e.target.value))}
              />
              <button
                className="qty-count qty-count--add"
                onClick={() => handleClick(index, "add")}
              >
                +
              </button>
            </div>
          }
          {item.isForTrail &&
            <div className="qty-input" style={{ width: "fit-content", border: 'none' }}>
              {item.quantity}
            </div>
          }
        </td>
        <td >{(item.taxPercentage / 100).toLocaleString("en-US", { style: "percent" })}</td>
        <td>{getBasePrice(item).toLocaleString("en-US", { style: "currency", currency: "INR" })}</td>
        <td>{getTax(item).toLocaleString("en-US", { style: "currency", currency: "INR" })}</td>
        <td >
          {(item.finalPrice * item.quantity).toLocaleString("en-US", { style: "currency", currency: "INR" })}
          /-
        </td>
        <td>
          <a className="text-danger delete-record" href="#!">
            <IconTrash size={22} className="me-1" />
          </a>
        </td>
      </tr>
    ));
  }, [
    aggregatedItems,
    handleQtyChange,
    handleClick
  ]);

  const handlelogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    logoutuser();
    Navigate("/login");
  };

  const createOrder = async () => {
    const userId = adminreduxinfo.id;
    let items = [];
    aggregatedItems.forEach((item, index) => {
      items.push({
        "itemId": item.packageId,
        "quantity": item.quantity,
        "discount": 0
      });
    });

    return await _post(`/sales-orders`,
      {
        "appUserId": userId,
        "subTotal": subtotal,
        "discountAmount": 0,
        "taxAmount": gst,
        "totalAmount": grandTotal,
        "items": items
      }).then(response => {
        return response.paymentId;
      }).catch(error => {
        if (error)
        hideLoader();
        return "";
      });
  };


  const paymentHandler = async (e) => {
    showLoader();
    const scriptLoaded = await loadRazorpayScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!scriptLoaded) {
      hideLoader();
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    let orderId = await createOrder();


    if (orderId != "") {
      var options = {
        key: config.paymentKey,
        currency: "INR",
        order_id: orderId,
        handler: async function (response) {
          await _post(`/sales-orders/payment`,
            {
              "paymentId": response.razorpay_payment_id,
              "orderId": response.razorpay_order_id,
              "signature": response.razorpay_signature
            })
            .then(response => {
              Navigate("/dashboard")
            })
            .catch(error => {
              if (error)
              hideLoader();
            });
        },
        prefill: {
          name: adminreduxinfo.firstName + " " + adminreduxinfo.lastName,
          email: adminreduxinfo.email,
          contact: adminreduxinfo.contactNo,
        },
        theme: {
          color: "#3399cc",
        },
      };

      var rzp1 = new window.Razorpay(options);
      rzp1.on("payment.failed", function (response) {
        alert(response.error.description);
      });
      rzp1.open();
    }
    e.preventDefault();
  };


  return (
    <div className="content-wrapper">
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="card mb-3">
          <div className="card-body">
            {/* <!-- Custom style1 Breadcrumb --> */}
            <nav
              aria-label="breadcrumb"
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
              <ol className="breadcrumb breadcrumb-style1 mb-0">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard" className="text-gray">
                    Dashboard
                  </NavLink>
                </li>
                <li className="breadcrumb-item text-primary">Cart</li>
              </ol>
              <div>
                <button
                  type="button"
                  className="btn btn-primary waves-effect waves-light"
                  onClick={handlelogout}
                >
                  Logout
                </button>
              </div>
            </nav>
            {/* <!--/ Custom style1 Breadcrumb --> */}
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-lg-8">
            <div className="card mb-6">
              <div className="card-datatable pt-0">
                <table className="table-bordered table rwd-table">
                  <thead>
                    <tr>
                      <th>
                        <b>S.No</b>
                      </th>
                      <th>
                        <b>Item name</b>
                      </th>
                      <th>
                        <b>Price</b>
                      </th>
                      <th>
                        <b>Quantity</b>
                      </th>
                      <th>
                        <b>Tax (%)</b>
                      </th>
                      <th>
                        <b>Basic</b>
                      </th>
                      <th>
                        <b>Tax</b>
                      </th>
                      <th>
                        <b>Total</b>
                      </th>
                      <th>
                        <b></b>
                      </th>
                    </tr>
                  </thead>
                  <tbody>{renderedAggregatedItems}</tbody>
                </table>
                <div className="d-flex justify-content-end me-3 mt-3">
                  <button
                    type="button"
                    className="btn btn-primary waves-effect waves-light"
                  >
                    Update Cart
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-4">
            <div className="card mb-6">
              <div className="card-header px-3 py-2">
                <h5 className="card-title m-0 mb-2">Cart Summary</h5>
              </div>
              <hr className="mt-0 mb-0" />
              <div className="card-body">
                <div className="d-flex align-items-center m-6 mb-4">
                  <div className="order-calculations w-100">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="w-px-100 text-heading">Sub Total :</span>
                      <h6 className="mb-0 text-dark">{subtotal.toLocaleString("en-US", { style: "currency", currency: "INR" })}</h6>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="w-px-100 text-heading">Tax Amount:</span>
                      <h6 className="mb-0 text-dark">{gst.toLocaleString("en-US", { style: "currency", currency: "INR" })}</h6>
                    </div>
                    <hr className="mt-0 mb-3" />
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6 className="w-px-100 mb-0 text-dark" style={{ fontWeight: "bold" }}>Total Amount:</h6>
                      <h6 className="mb-0 text-dark" style={{ fontWeight: "bold" }}>{grandTotal.toLocaleString("en-US", { style: "currency", currency: "INR" })}</h6>
                    </div>
                    <div className="d-none justify-content-between align-items-center">
                      <input
                        type="text"
                        className="form-control w-90 me-3"
                        placeholder="Coupon Code"
                      />
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn btn-primary waves-effect waves-light" style={{ float: "right" }}
                  onClick={paymentHandler}
                >
                  Make Payment
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
